import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const navItems = [
    { path: '/admin', icon: 'LayoutDashboard', label: 'Dashboard', exact: true },
    { path: '/admin/users', icon: 'Users', label: 'Users' },
    { path: '/admin/invitations', icon: 'Mail', label: 'Invitations' },
    { path: '/admin/templates', icon: 'FileText', label: 'Email Templates' },
    { path: '/admin/music', icon: 'Music', label: 'Music Library' },
    { path: '/admin/reports', icon: 'BarChart3', label: 'Reports' },
    { path: '/admin/settings', icon: 'Settings', label: 'Settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-white border-r border-gray-100 flex flex-col transition-all duration-300 flex-shrink-0`}>
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          {sidebarOpen && (
            <img src="https://cloud.sharemyimage.com/2026/08/16/DayClap-Logo.png" alt="DayClap" className="h-8 object-contain" />
          )}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-gray-100 rounded-lg">
            <SafeIcon name={sidebarOpen ? 'PanelLeftClose' : 'PanelLeftOpen'} className="text-gray-500" />
          </button>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-sm font-medium ${
                  isActive
                    ? 'bg-pink-50 text-pink-700 shadow-sm'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800'
                }`
              }
            >
              <SafeIcon name={item.icon} className="text-lg flex-shrink-0" />
              {sidebarOpen && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-gray-100">
          <button
            onClick={() => navigate('/home')}
            className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-500 hover:bg-gray-50 w-full"
          >
            <SafeIcon name="ArrowLeft" className="text-lg flex-shrink-0" />
            {sidebarOpen && <span>Back to App</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;